import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo-brand.svg'


const _hoisted_1 = { class: "min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8 p-7" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sm:mx-auto sm:w-full" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mx-auto",
    src: _imports_0,
    alt: "Logo"
  }),
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-10 text-center text-5xl font-extrabold" }, " Create new Password ")
], -1)
const _hoisted_3 = { class: "mt-12 sm:mx-auto sm:w-full sm:max-w-md md:max-w-3xl" }
const _hoisted_4 = { class: "bg-white py-16 px-14 shadow sm:rounded-lg" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mb-10 text-center" }, "Please enter new password", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block text-2xl font-medium text-gray-700"
}, " Old Password ", -1)
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "passwordConfirm",
  class: "block text-2xl font-medium text-gray-700"
}, " New Password ", -1)
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "text-center mt-12" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Did you remember your password? ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Sign In")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorDisplay = _resolveComponent("ErrorDisplay")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            class: "space-y-6",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _hoisted_5,
            _createElementVNode("div", null, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  id: "password",
                  name: "password",
                  type: "password",
                  required: "",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newPasswordForm.oldPassword) = $event)),
                  class: "input-auth"
                }, null, 512), [
                  [_vModelText, _ctx.newPasswordForm.oldPassword]
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  id: "passwordConfirm",
                  name: "passwordConfirm",
                  type: "password",
                  required: "",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.newPassword.$model) = $event)),
                  class: "input-auth"
                }, null, 512), [
                  [_vModelText, _ctx.v$.newPassword.$model]
                ])
              ])
            ]),
            (_ctx.v$.newPassword.$error)
              ? (_openBlock(), _createBlock(_component_ErrorDisplay, {
                  key: 0,
                  "error-message": "Your password must be",
                  "error-message-two": "At least 8 characters",
                  "error-message-three": "One number",
                  "error-message-four": "One Uppercase letter",
                  "error-message-five": "One Lowercase letter"
                }))
              : _createCommentVNode("", true),
            (_ctx.errorMessageConfirmPass)
              ? (_openBlock(), _createBlock(_component_ErrorDisplay, {
                  key: 1,
                  "error-message": _ctx.errorMessageConfirmPass
                }, null, 8, ["error-message"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleNewPassword && _ctx.handleNewPassword(...args))),
                type: "submit",
                class: _normalizeClass(["btn-main", [{ disabled: _ctx.v$.$invalid || _ctx.isLoading }]]),
                disabled: _ctx.v$.$invalid || _ctx.isLoading
              }, _toDisplayString(!_ctx.isLoading ? 'Submit' : 'Processing...'), 11, _hoisted_10)
            ])
          ], 32)
        ])
      ]),
      _createElementVNode("p", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_router_link, {
          to: "/login",
          class: "text-success"
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        })
      ])
    ])
  ]))
}